import React, { Component } from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import { connect } from "react-redux";
import { updatePosition } from "../../redux/actions";

class MyMarker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accuracy: 0,
    };
  }

  onPositionError = (error) => {
    console.error(error);

    switch (error.code) {
      case 1:
        console.info('Użytkownik nie zezwolił na geolokalizację.');
        break;

      case 2:
        console.warn('Nie udało się ustalić lokalizacji.');
        break;

      case 3:
        console.warn('Przekroczono czas oczekiwania na lokalizację.');
        break;

      default:
        console.warn('Nieznany problem z geolokalizacją.');
    }
  };

  onPosition = (position) => {
    if (this.state.accuracy !== position.coords.accuracy) {
      this.setState({ accuracy: position.coords.accuracy });
    }

    this.props.dispatch(
      updatePosition({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
    );
  };

  componentDidMount() {
    if (navigator.geolocation) {
      let options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      navigator.geolocation.getCurrentPosition(this.onPosition);
      navigator.geolocation.watchPosition(
        this.onPosition,
        this.onPositionError,
        options
      );
    }
  }

  render() {
    // let myPosIcon = L.icon({
    //     iconUrl: require('./../../assets/images/smartphone.svg'),
    //     iconSize: [28, 55], // size of the icon
    // })
    const customMarker = L.icon({
      iconUrl: require("./../../../assets/images/smartphone2.svg"),
      iconSize: [24, 24],
      shadowUrl:
        this.state.accuracy && this.state.accuracy > 0
          ? require("./../../../assets/images/circle.png")
          : "",
      shadowSize: [this.state.accuracy, this.state.accuracy],
    });

    return this.props.data.currentPosInBounds ? (
      <Marker
        position={this.props.data.currentPos}
        icon={customMarker}></Marker>
    ) : (
      ""
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default connect(mapStateToProps)(MyMarker);



// WEBPACK FOOTER //
// ./src/js/components/current-location-marker/index.js